import classNames from 'classnames';

import { Skeleton } from 'components/Skeleton';

import classes from './loadingPage.module.css';

type LoadingPageProps = {
  className?: string;
  style?: React.CSSProperties;
  variant?: 'table' | 'card' | 'default';
};

export const LoadingPage = ({ className, style, variant = 'default' }: LoadingPageProps) => {
  if (variant === 'table') {
    return (
      <div className={classes.skeletonContainer} style={style}>
        <div className={classes.skeletonTable}>
          {/* Header row */}
          <div className={classes.skeletonRow}>
            {[1, 2, 3, 4].map((i) => (
              <div key={`header-${i}`} className={classes.skeletonHeaderCell}>
                <Skeleton height="16px" width="80%" />
              </div>
            ))}
          </div>
          {/* Data rows */}
          {[1, 2, 3, 4, 5, 6].map((row) => (
            <div key={`row-${row}`} className={classes.skeletonRow}>
              {[1, 2, 3, 4].map((cell) => (
                <div key={`cell-${row}-${cell}`} className={classes.skeletonCell}>
                  <Skeleton height="20px" width="90%" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className={classes.skeletonContainer} style={style}>
        <div className={classes.skeletonCard}>
          <Skeleton height="32px" width="60%" className={classes.skeletonTitle} />
          <Skeleton height="20px" width="100%" className={classes.skeletonText} />
          <Skeleton height="20px" width="100%" className={classes.skeletonText} />
          <Skeleton height="20px" width="70%" className={classes.skeletonTextShort} />
        </div>
      </div>
    );
  }

  return (
    <div
      className={className ? classNames(classes.loadingPage, className) : classes.loadingPage}
      style={style}
    >
      <div className={classes.skeletonDefault}>
        <Skeleton height="32px" width="60%" className={classes.skeletonTitle} />
        <Skeleton height="20px" width="100%" className={classes.skeletonText} />
        <Skeleton height="20px" width="100%" className={classes.skeletonText} />
        <Skeleton height="20px" width="70%" className={classes.skeletonTextShort} />
      </div>
    </div>
  );
};
